/**
 * @module app.core
 */

import { autoinject, bindingMode } from 'aurelia-framework';
import { ComponentBase, IForm } from 'app/shared/lib/essette-site';
import { bindable } from 'aurelia-typed-observable-plugin';
import { MemberService } from 'app/cd/services/member-service';
import { apiCall } from 'app/shared/lib/essette-api';
import { Toaster } from 'app/shared/lib/toaster';
import { I18N } from 'aurelia-i18n';
import * as CD from 'app/cd/models/essette-api';

@autoinject()
export class SaveAidCode extends ComponentBase implements IForm {

  ////****************** Fields and Properties ************************************////
  @bindable({ defaultBindingMode: bindingMode.toView })
  protected memberPlanId: string = "";

  @bindable({ defaultBindingMode: bindingMode.toView })
  protected aidCodes: ReadonlyArray<CD.AidCode> = [];

  public memberAidCode: CD.MemberAidCode | null | undefined = null;
  public aidCode: CD.AidCode | null | undefined = null;
  public aidCodeStart: string | null | undefined = '';
  public aidCodeEnd: string | null | undefined = '';

  ////****************** Lifecycle events (in order of execution) *****************////
  constructor(
    private readonly memberService: MemberService,
    private readonly toaster: Toaster,
    private readonly i18n: I18N,
    ...rest: any[]) {
    super(...rest);
  }

  ////****************** Events ***************************************************////

  ////****************** Functions ************************************************////
  protected buildMemberAidCode(): CD.MemberAidCode {
    const memberAidCode: CD.MemberAidCode = {
      "id": this.memberAidCode?.id,
      "member": {
        "plan": {
          "id": this.memberPlanId
        }
      },
      "aidCode": {
        "id": this.aidCode?.id
      },
      "dateRange": {
        "start": this.aidCodeStart,
        "end": this.aidCodeEnd
      },
      "isActive": true
    };

    return memberAidCode;
  }

  ////****************** IForm ****************************************************////
  public hasChanges(): boolean {
    throw new Error('Method not implemented.');
  }

  public async submit(): Promise<boolean> {
    const memberAidCode: CD.MemberAidCode = this.buildMemberAidCode();
    const isSuccessful = await this.saveAidCode(memberAidCode);
    return isSuccessful;
  }

  ////****************** Service Calls ********************************************////
  @apiCall
  protected async saveAidCode(memberAidCode: CD.MemberAidCode): Promise<boolean> {
    if(!memberAidCode.member?.plan?.id || !memberAidCode.aidCode?.id || !memberAidCode.dateRange?.start) { return false; }

    let isSuccessful = false;
    let errorMessage: string = "";
    let duplicateRecord: boolean = false;

    try {
      this.state.beginSave();
      const response = await this.memberService.saveMemberAidCode(memberAidCode);
      isSuccessful = response.isSuccessful;

      return isSuccessful;
    }
    catch(error) {
      if(error.description) { errorMessage = error.description; }
      duplicateRecord = error.status.errors.some((err: any) => err.code === 'property.constraintViolated');
      throw error;
    }
    finally {
      if(isSuccessful) {
        if(memberAidCode.id) {
          this.toaster.standard.updated('cd:aidCode.$', isSuccessful);
        } else {
          this.toaster.standard.created('cd:aidCode.$', isSuccessful);
        }
      } else {
        if(duplicateRecord) {
          if(memberAidCode.id) {
            this.toaster.error().message(this.i18n.tr('ui:messages.duplicate.update_error', { what: this.i18n.tr('cd:provider.startDate.$'), item: this.i18n.tr('cd:aidCode.$') })).show();
          } else {
            this.toaster.error().message(this.i18n.tr('ui:messages.duplicate.create_error', { what: this.i18n.tr('cd:provider.startDate.$'), item: this.i18n.tr('cd:aidCode.$') })).show();
          }
        } else {
          const exception = (this.toaster.toast())
            .title('Error')
            .class('ess-toast-error')
            .icon('ui:icons.error')
            .message(errorMessage)
          exception.show();
        }
      }
      this.state.endSave();
    }
  }
}
